module.exports = __webpack_public_path__ + "img/qesg_logo.a10bc11d.png";